import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { ExploreButtonFilled, ExploreButtonHollow } from "shared/pages/explore/styles";
import styled from "styled-components";

export const ConfirmWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    display: flex;
    justify-content: center;
    place-items: end;

    height: 50vh;

    z-index: 9999999;
`;

export const ConfirmContent = styled(FlexBox)`
    flex-flow: column;
    justify-content: center;
    position: relative;

    border-radius: 8px;
    margin: 0 auto;
    width: 560px;
    max-width: 560px;
    padding: 32px 40px;
    // height: 232px;
    // max-height: 272px;
    place-items: center;
    border: 1px solid #E7E7E7;
    background: #FEFEFE;
`;

export const ConfirmText = styled.div`
    font-family: 'Inter';
    font-size: 28px;
    line-height: 34px;
    font-weight: 600;
    max-width: 480px;
    text-align: left;
`;

export const SecondText = styled.div`
    font-family: 'Inter';
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    max-width: 480px;
    text-align: left;
`;

export const CloseWrapper = styled.div`
    position: absolute;
    top: 24px;
    right: 26px;
    cursor: pointer;

    &:hover {
        svg path {
          fill: ${(p) => p.theme.modal.closeColor};
        }
      }

`;

export const HollowButton = styled(ExploreButtonHollow)`
    width: 168px !important;
    min-width: 168px !important;
    height: 48px !important;
    color: ${Colors.zel};

    @media(max-width: ${LayoutConst.screen.md}px) {
        width: 100% !important;
        height: 36px !important;
        min-width: auto !important;
        max-width: 100%;
    }
`;

export const FilledButton = styled(ExploreButtonFilled)`
    width: 288px !important;
    min-width: 288px !important;
    height: 48px !important;
        color: ${({theme}) => theme.projectEdit.publishModal.buttons.hollow.color} !important;
    border: 1px solid #575B5E;

    &:hover {
        color: ${Colors.geoWhite100} !important;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        width: 100% !important;
        min-width: auto !important;
        height: 36px !important;
        max-width: 100%;
    }
`;import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { ExploreButtonFilled, ExploreButtonHollow } from "shared/pages/explore/styles";
import styled from "styled-components";

export const ConfirmWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    display: flex;
    justify-content: center;
    place-items: end;

    height: 50vh;

    z-index: 9999999;
`;

export const ConfirmContent = styled(FlexBox)`
    flex-flow: column;
    justify-content: center;
    position: relative;

    border-radius: 8px;
    margin: 0 auto;
    width: 560px;
    max-width: 560px;
    padding: 32px 40px;
    // height: 232px;
    // max-height: 272px;
    place-items: center;
    border: 1px solid #E7E7E7;
    background: #FEFEFE;
`;

export const ConfirmText = styled.div`
    font-family: 'Inter';
    font-size: 28px;
    line-height: 34px;
    font-weight: 600;
    max-width: 480px;
    text-align: left;
`;

export const SecondText = styled.div`
    font-family: 'Inter';
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    max-width: 480px;
    text-align: left;
`;

export const CloseWrapper = styled.div`
    position: absolute;
    top: 24px;
    right: 26px;
    cursor: pointer;

    &:hover {
        svg path {
          fill: ${(p) => p.theme.modal.closeColor};
        }
      }

`;

export const HollowButton = styled(ExploreButtonHollow)`
    width: 168px !important;
    min-width: 168px !important;
    height: 48px !important;
    color: ${Colors.zel};

    @media(max-width: ${LayoutConst.screen.md}px) {
        width: 100% !important;
        height: 36px !important;
        min-width: auto !important;
        max-width: 100%;
    }
`;

export const FilledButton = styled(ExploreButtonFilled)`
    width: 288px !important;
    min-width: 288px !important;
    height: 48px !important;
        color: ${({theme}) => theme.projectEdit.publishModal.buttons.hollow.color} !important;
    border: 1px solid #575B5E;

    &:hover {
        color: ${Colors.geoWhite100} !important;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        width: 100% !important;
        min-width: auto !important;
        height: 36px !important;
        max-width: 100%;
    }
`;